export enum ExportReportType {
  Radius = 'Radius',
  Location = 'Location',
  Boundary = 'Boundary',
  DriveTimePolygon = 'DriveTimePolygon',
}
